import IDemandaEspecifica from '../interfaces/IDemandaEspecifica';
import { CARREGAR_DEMANDAS_ESPECIFICAS } from './actionTypes';

export const carregarDemandasEspecificas = (demandasEspecificas: IDemandaEspecifica[]) => {
  return {
    type: CARREGAR_DEMANDAS_ESPECIFICAS,
    state: demandasEspecificas
  };
};